(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["youtube-video-structured-data-container"] && !Shopify.designMode) return;
  try {
    // Simple YouTube Structured Data Injector
    (function() {
      'use strict';

      // Find all video data containers
      const videoContainers = document.querySelectorAll('.youtube-video-structured-data');

      videoContainers.forEach((container, index) => {
        const productHandle = container.dataset.productHandle;

        if (!productHandle) return;

        // Fetch and inject schema for this product
        fetch('/apps/api/youtube-schema', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: productHandle })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success && data.schema) {
            // Create unique script element for this instance
            const scriptElement = document.createElement('script');
            scriptElement.type = 'application/ld+json';
            scriptElement.id = `youtube-structured-data-${productHandle}-${index}`;
            scriptElement.textContent = JSON.stringify(data.schema);
            document.head.appendChild(scriptElement);
          }
        })
        .catch(error => {
          // Silent fail - structured data is enhancement, not critical
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
